"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generalHthHelper = void 0;
class GeneralHthHelper {
  GetCharacterForNumber = (numberToChange, hasNn = false) => {
    if (numberToChange === 1) return 'A';
    if (numberToChange === 2) return 'B';
    if (numberToChange === 3) return 'C';
    if (numberToChange === 4) return 'D';
    if (numberToChange === 5) return 'E';
    if (numberToChange === 6) return 'F';
    if (numberToChange === 7) return 'G';
    if (numberToChange === 8) return 'H';
    if (numberToChange === 9) return 'I';
    if (numberToChange === 10) return 'J';
    if (numberToChange === 11) return 'K';
    if (numberToChange === 12) return 'L';
    if (numberToChange === 13) return 'M';
    if (numberToChange === 14) return 'N';
    if (numberToChange === 15) return hasNn ? 'Ñ' : 'O';
    if (numberToChange === 16) return hasNn ? 'O' : 'P';
    if (numberToChange === 17) return hasNn ? 'P' : 'Q';
    if (numberToChange === 18) return hasNn ? 'Q' : 'R';
    if (numberToChange === 19) return hasNn ? 'R' : 'S';
    if (numberToChange === 20) return hasNn ? 'S' : 'T';
    if (numberToChange === 21) return hasNn ? 'T' : 'U';
    if (numberToChange === 22) return hasNn ? 'U' : 'V';
    if (numberToChange === 23) return hasNn ? 'V' : 'W';
    if (numberToChange === 24) return hasNn ? 'W' : 'X';
    if (numberToChange === 25) return hasNn ? 'X' : 'Y';
    if (numberToChange === 26) return hasNn ? 'Y' : 'Z';
    if (numberToChange === 27) return hasNn ? '?' : 'Z';
    return '?';
  };
  GetLastCheckTimestamp = (h, config) => {
    const validStates = config.isEnabledHthDoubleState ? [1] : [1, 2];
    const timestamps = h.history.filter(x => validStates.includes(x.state)).map(x => x.timestamp);
    return timestamps.length ? Math.max(...timestamps) : -Infinity;
  };
  MaskTheBlock = (block, usingLettersForBlock) => usingLettersForBlock ? this.GetCharacterForNumber(parseInt(block)) : block;
  MaskTheFace = (face, usingLettersForBlock) => {
    if (!usingLettersForBlock) {
      return face;
    }
    if (face === 'A') return 1;
    if (face === 'B') return 2;
    if (face === 'C') return 3;
    if (face === 'D') return 4;
    if (face === 'E') return 5;
    if (face === 'F') return 6;
    // if (face === 'G') return 7;
    // if (face === 'H') return 8;
    // if (face === 'I') return 9;
    // if (face === 'J') return 10;
    // if (face === 'K') return 11;
    return 0;
  };
}
exports.generalHthHelper = new GeneralHthHelper();